import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const profileCompleteGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isProfileComplete()) {
    return true;
  }

  // Pass an optional query parameter or just redirect to profile
  return router.createUrlTree(['/app/profile']);
};
